import React from "react";
import { Helmet } from "react-helmet-async";
import { useSite } from "../context/SiteContext";

export default function SEO({ title, description, keywords, ogImage, canonical, noindex, jsonLd, type = "website" }) {
  const { site } = useSite();
  const defSeo = site?.defaultSeo || {};
  const finalTitle = title || defSeo.title || `${site?.brand || "OnlineCricketID"} - Cricket ID`;
  const finalDesc = description || defSeo.description || "";
  const finalKeywords = keywords || defSeo.keywords || "";
  const finalImg = ogImage || defSeo.ogImage || "";
  const origin = (defSeo.canonical || "").replace(/\/$/, "");
  const path = typeof window !== "undefined" ? window.location.pathname : "";
  const finalCanonical = canonical || (origin ? `${origin}${path}` : (typeof window !== "undefined" ? window.location.href : ""));

  return (
    <Helmet>
      <title>{finalTitle}</title>
      <meta name="description" content={finalDesc} />
      {finalKeywords && <meta name="keywords" content={finalKeywords} />}
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      {finalCanonical && <link rel="canonical" href={finalCanonical} />}
      {/* OG */}
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={finalDesc} />
      <meta property="og:type" content={type} />
      {finalImg && <meta property="og:image" content={finalImg} />}
      {finalCanonical && <meta property="og:url" content={finalCanonical} />}
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={finalTitle} />
      <meta name="twitter:description" content={finalDesc} />
      {finalImg && <meta name="twitter:image" content={finalImg} />}
      {jsonLd && <script type="application/ld+json">{jsonLd}</script>}
    </Helmet>
  );
}
